/*
  Quick-add sheet for multi-variant collection cards (_t-pc-buy.liquid).

  One shared <dialog> serves the whole grid, built on first open from the
  clicked card's JSON payload. Choosing options rewrites that card form's hidden
  variant id and submits the form, so Horizon's AJAX add + cart-drawer pop run
  exactly as they do for a single-variant one-tap add.

  Plain script, not an ES module — TORRAS card blocks don't use the @theme
  importmap. Loaded once per page even though every case card links it.
*/
(function () {
  if (window.__tPcQuickAdd) return;
  window.__tPcQuickAdd = true;

  var ADD_TIMEOUT = 8000; // safety net: never leave the button spinning forever

  var dialog, state;

  /* The payload ships ONE Shopify CDN url per variant (…&width=800) to keep the
     per-card JSON as light as it was at 240w. Widths are cheap to re-derive from
     that url, so the retina ladder is built here rather than in Liquid — a 24-card
     grid would otherwise carry 3 extra urls per variant in the HTML. */
  function resize(url, w) {
    return url && /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url;
  }
  function srcsetFor(url) {
    if (!url || !/[?&]width=\d+/.test(url)) return '';
    return [480, 800, 1200].map(function (w) { return resize(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  /* Swapping media between models: only touch the DOM when the url really changed,
     so re-rendering after a colour tap doesn't restart a decode (visible flash). */
  function setMedia(url) {
    var img = dialog.querySelector('.t-qa__img');
    if (!url || img.getAttribute('src') === url) return;
    /* Fade in on load. The sheet sets src only once it opens, so on a phone there is
       always a gap before the shot lands — and with the media box now a calm 24svh of
       near-white, that gap read as "the product image is broken" rather than "still
       loading" (Bing, 2026-09-19). Holding the box empty-but-animating says which. */
    img.classList.remove('is-ready');
    img.setAttribute('src', url);
    img.setAttribute('srcset', srcsetFor(url));
    if (img.complete && img.naturalWidth) img.classList.add('is-ready');
  }

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 't-qa';
    dialog.innerHTML =
      '<button type="button" class="t-qa__close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
      '</button>' +
      '<div class="t-qa__head">' +
        '<div class="t-qa__media">' +
          /* `sizes` must describe the box the shot is PAINTED in, not the column it
             sits in. On phones `.t-qa__img` is capped at 24svh and object-fit:contain
             keeps it square, so it renders about 190px across — but this used to claim
             100vw (~400px), and a DPR-3 phone then fetched the 1200w candidate for it.
             15rem is the honest upper bound: the cap only shrinks on shorter phones and
             in landscape. Desktop keeps the fixed media column, minus its padding. */
          '<img class="t-qa__img" alt="" width="800" height="800" decoding="async" ' +
            'sizes="(max-width: 768px) 15rem, 20rem">' +
        '</div>' +
        '<div class="t-qa__meta">' +
          '<a class="t-qa__title"></a>' +
          '<p class="t-qa__desc" hidden></p>' +
          '<p class="t-qa__price"><span class="t-qa__now"></span><s class="t-qa__was"></s></p>' +
        '</div>' +
      '</div>' +
      '<div class="t-qa__opts"></div>' +
      /* The CTA is wrapped so the sticky footer can be a real padded band. Sticking
         the bare button instead needs a plate to fill its own margins, and the usual
         `::before{z-index:-1}` trick can't provide one: `position:sticky` forms a
         stacking context, so a negative-z child paints ABOVE the button's own
         background rather than behind it — the CTA disappears. */
      /* `.t-qa__more` names the option row that is still below the fold ("Color ⌄").
         Only ever shown on the phone sheet, and only when the compact header was not
         enough to fit every row — see syncOptsScroll(). */
      '<div class="t-qa__foot">' +
        '<button type="button" class="t-qa__more" hidden>' +
          '<span class="t-qa__more-in"><span class="t-qa__more-name"></span>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></span>' +
        '</button>' +
        '<button type="button" class="t-qa__add"></button>' +
      '</div>';

    dialog.querySelector('.t-qa__close').addEventListener('click', function () { dialog.close(); });
    dialog.querySelector('.t-qa__add').addEventListener('click', submit);
    dialog.querySelector('.t-qa__more').addEventListener('click', revealMore);
    dialog.querySelector('.t-qa__opts').addEventListener('scroll', syncMore, { passive: true });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { state = null; unlockPage(); });
    /* One listener for the life of the sheet rather than per swap: `load` fires for
       whichever src is current, and a decode that is already done when src is set
       never fires it at all — setMedia() covers that case with img.complete. */
    var media = dialog.querySelector('.t-qa__img');
    media.addEventListener('load', function () { media.classList.add('is-ready'); });
    media.addEventListener('error', function () { media.classList.add('is-ready'); });
    document.body.appendChild(dialog);
  }

  /* Freeze the page behind the sheet. showModal()'s backdrop blocks taps, but iOS
     Safari still lets a drag on it scroll the document — and a scrolling document is
     what makes Safari swap its compact address pill for the full toolbar. Even with
     the sheet sized in `svh` (fixed height, see _t-pc-buy.liquid) that swap shifts
     everything on screen while the shopper is aiming at a chip. position:fixed is the
     only lock iOS honours; `overflow:hidden` alone does not hold there. Restoring the
     scroll offset is mandatory — dropping it teleports the shopper to the top of the
     collection when the sheet closes. */
  var lockedAt = 0;
  function lockPage() {
    lockedAt = window.scrollY || document.documentElement.scrollTop || 0;
    var b = document.body.style;
    b.position = 'fixed';
    b.top = -lockedAt + 'px';
    b.left = '0';
    b.right = '0';
    b.width = '100%';
  }
  function unlockPage() {
    var b = document.body.style;
    if (b.position !== 'fixed') return;
    b.position = b.top = b.left = b.right = b.width = '';
    /* Instant: base.css sets a global `scroll-behavior:smooth`, which would animate
       this restore and leave the page visibly gliding back after the sheet is gone. */
    var prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockedAt);
    document.documentElement.style.scrollBehavior = prev;
  }

  /* The variant whose options match the current selection exactly. */
  function resolve() {
    return state.data.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === state.selected[i]; });
    });
  }

  /* A value is offered when some in-stock variant carries it alongside the
     selections made for the *other* option rows. */
  function offered(index, value) {
    return state.data.variants.some(function (v) {
      if (!v.available || v.options[index] !== value) return false;
      return v.options.every(function (o, i) { return i === index || o === state.selected[i]; });
    });
  }

  /* Could this value EVER be bought, ignoring what the other rows currently hold?
     Used for the driving rows (device / finish), which must stay reachable: hiding
     them on the current colour can strand a shopper — pick a colour sold only for
     one model and every other model vanishes, with no way back. Colours are the
     dependent row and use offered() instead. */
  function everOffered(index, value) {
    return state.data.variants.some(function (v) {
      return v.available && v.options[index] === value;
    });
  }

  function firstImageFor(index, value) {
    var v = state.data.variants.find(function (x) { return x.options[index] === value && x.image; });
    return v ? v.image : '';
  }

  function render() {
    var d = state.data;
    var wrap = dialog.querySelector('.t-qa__opts');
    wrap.innerHTML = '';

    d.options.forEach(function (opt, index) {
      /* A row is dots when it is the product's Colour option, or when the payload says so:
         bundle parents' "Case Color" / "Lens Color" rows borrow component swatches and ship
         `swatch: true` (snippets/torras-qa-buy.liquid). No flag, no change. */
      var isSwatch = /^colou?r$/i.test(opt.name) || opt.swatch === true;
      var row = document.createElement('div');
      row.className = 't-qa__row';

      /* Label left, current value right — the PDP's option-row convention. It is
         the ONLY place a swatch row's colour name is visible (the swatches
         themselves are dots), so it is not decoration. */
      var head = document.createElement('div');
      head.className = 't-qa__rowhead';
      var label = document.createElement('p');
      label.className = 't-qa__label';
      label.textContent = opt.name;
      var picked = document.createElement('p');
      picked.className = 't-qa__picked';
      picked.textContent = state.selected[index] || '';
      head.appendChild(label);
      head.appendChild(picked);
      row.appendChild(head);

      /* Non-swatch values (device models, finishes) go in a fixed 2-column grid:
         equal-width cells line up in columns instead of wrapping ragged, and long
         labels like "iPhone 17 Pro Max" set the width for everything. Matches the
         PDP model picker (blocks/torras-pdp-options.liquid). */
      var list = document.createElement('div');
      list.className = 't-qa__vals' + (isSwatch ? ' t-qa__vals--swatch' : ' t-qa__vals--grid');

      opt.values.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 't-qa__val';
        btn.setAttribute('aria-pressed', String(state.selected[index] === val.name));
        /* A colour that does not exist for the chosen model is not a choice, so it is
           REMOVED, not dimmed — Ostand Q3 Rugg on iPhone 17 Pro was showing Ocean Blue
           (sold out) and Moss Green (never made for it) as faded-but-clickable dots.
           Driving rows are judged on the whole variant list so they stay reachable;
           one that can't be bought in any colour is gone for good and also drops out.
           Never hide what is currently selected — the row must keep a visible anchor. */
        var live = isSwatch ? offered(index, val.name) : everOffered(index, val.name);
        if (!live && state.selected[index] !== val.name) btn.classList.add('is-gone');

        /* Prefer the option's swatch colour — a true, consistently-framed dot.
           Variant photos vary in crop, so a 36px thumbnail of a pale case can
           read as an empty box; use one only when no swatch colour is set. */
        if (isSwatch) {
          /* Swatch rows render the colour only (no visible text — see the CSS), so the
             name has to live on the button for a11y + hover tooltip. */
          btn.title = val.name;
          btn.setAttribute('aria-label', val.name);
          var thumbSrc = val.color ? '' : firstImageFor(index, val.name);
          if (val.color) {
            var chip = document.createElement('span');
            chip.className = 't-qa__chip';
            chip.style.background = val.color;
            btn.appendChild(chip);
          } else if (thumbSrc) {
            var thumb = document.createElement('img');
            /* 44px chip — pull it down from the sheet's 800w media url. */
            thumb.src = resize(thumbSrc, 120);
            thumb.alt = '';
            thumb.loading = 'lazy';
            thumb.width = 44;
            thumb.height = 44;
            btn.appendChild(thumb);
          }
        }

        var name = document.createElement('span');
        name.className = 't-qa__val-name';
        name.textContent = val.name;
        btn.appendChild(name);

        btn.addEventListener('click', function () {
          state.selected[index] = val.name;
          /* Remembered for the photo: see optionMedia in render(). A bundle's Model row
             (payload has modelMedia; the row is always first) is not a photo pick — keep
             the last colour so switching model re-shows that colour for the new device. */
          if (!(d.modelMedia && index === 0)) state.lastPick = { name: opt.name, value: val.name };
          /* Keep the rest of the selection valid: if the new value has no
             in-stock partner for another row, slide that row to one it does. */
          d.options.forEach(function (o, i) {
            if (i === index || offered(i, state.selected[i])) return;
            var fix = o.values.find(function (x) { return offered(i, x.name); });
            if (fix) state.selected[i] = fix.name;
          });
          render();
        });

        list.appendChild(btn);
      });

      row.appendChild(list);
      wrap.appendChild(row);
    });

    var variant = resolve();
    var add = dialog.querySelector('.t-qa__add');
    var was = dialog.querySelector('.t-qa__was');

    dialog.querySelector('.t-qa__now').textContent = variant ? variant.price : '';
    was.textContent = variant && variant.compare ? variant.compare : '';
    was.hidden = !(variant && variant.compare);
    /* Photo: the variant's own image. Bundle parents ship none — their payload carries
       optionMedia instead (snippets/torras-qa-buy.liquid) — so there the photo follows the
       option just picked through the media alt "<Option>: <Value>", falling back to the
       bare value: the rule the PDP gallery jumps by. No optionMedia, no change. */
    var media = variant ? variant.image : '';
    /* Bundle model row: each device's own alt-tagged photos (snippets/torras-qa-payload-plain.liquid). */
    var optionMedia = (d.modelMedia && d.modelMedia[state.selected[0]]) || d.optionMedia;
    if (optionMedia && state.lastPick) {
      var pick = state.lastPick;
      media = optionMedia[(pick.name + ': ' + pick.value).toLowerCase()]
        || optionMedia[String(pick.value).toLowerCase()]
        || media;
    }
    if (media) setMedia(media);

    /* Keep the title's PDP link on what the sheet is showing. Model entries carry
       their own url (a sibling model IS another product); plain entries derive
       ?variant= from the card product's url. Without this a device-filtered grid
       seeds a non-default variant but the link lands back on first-available. */
    dialog.querySelector('.t-qa__title').href = variant
      ? variant.url || d.url + '?variant=' + variant.id
      : d.url;

    add.classList.remove('is-loading', 'is-added');
    add.removeAttribute('aria-label');
    add.disabled = !(variant && variant.available);
    add.textContent = !variant
      ? d.labels.unavailable
      : variant.available ? d.labels.cta : d.labels.soldOut;

    syncOptsScroll();
  }

  /* The option row is its own scroll area on mobile (see `.t-qa__opts` in
     blocks/_t-pc-buy.liquid). Three steps, each only if the one before was not enough:
       1. the sheet as designed (media banner) fits every row → nothing changes;
       2. it does not → `is-compact` folds the banner into a thumbnail beside the
          title, which hands the option rows ~120px back;
       3. still does not (a ten-model grid) → the hint above the CTA names the row
          that is below the fold.
     Before this, a Model × Colour product on a phone showed one and a half rows and
     a 20px fade: the Colour row sat under the CTA and shoppers did not know it was
     there (Bing, screen recording, 2026-09-30).
     Deferred a frame because render() is called BEFORE showModal(), and a closed
     <dialog> has no layout: measuring there returns 0 for both heights. The frame
     still lands before the sheet's first paint, so the header never visibly jumps. */
  function syncOptsScroll() {
    requestAnimationFrame(function () {
      var wrap = dialog && dialog.querySelector('.t-qa__opts');
      if (!wrap || !state) return;
      /* Header shape is decided ONCE per open, from the banner layout. Re-deciding
         on every tap would let the header change shape under the shopper's finger
         whenever a pick hides or reveals a colour. */
      if (!state.measured) {
        state.measured = true;
        dialog.classList.remove('is-compact');
        if (wrap.scrollHeight - wrap.clientHeight > 1) dialog.classList.add('is-compact');
        /* Always OPEN at the top. showModal() focuses the first control inside the
           sheet and the UA scrolls it into view, so this has to be re-zeroed rather
           than just left alone. Later renders keep the offset: a shopper who scrolled
           down to Colour and tapped a dot must not be thrown back to the top. */
        wrap.scrollTop = 0;
      }
      dialog.classList.toggle('is-opts-scrollable', wrap.scrollHeight - wrap.clientHeight > 1);
      syncMore();
    });
  }

  /* The row the hint should name. A row whose LABEL is still out of sight (or under
     the hint's own fade) is one the shopper does not know exists — that wins. Only
     when every label is showing does it fall back to the row whose values are cut,
     so a long Model grid says "Color" rather than pointing at itself first. */
  function rowBelowFold(wrap) {
    var edge = wrap.getBoundingClientRect().bottom;
    var rows = wrap.querySelectorAll('.t-qa__row');
    var cut = null;
    for (var i = 0; i < rows.length; i++) {
      var label = rows[i].querySelector('.t-qa__label');
      if (label && label.getBoundingClientRect().bottom - edge > -24) return rows[i];
      if (!cut && rows[i].getBoundingClientRect().bottom - edge > 8) cut = rows[i];
    }
    return cut;
  }

  function syncMore() {
    var wrap = dialog && dialog.querySelector('.t-qa__opts');
    var more = dialog && dialog.querySelector('.t-qa__more');
    if (!wrap || !more) return;
    var left = wrap.scrollHeight - wrap.clientHeight - wrap.scrollTop;
    var row = left > 8 ? rowBelowFold(wrap) : null;
    var label = row && row.querySelector('.t-qa__label');
    more.hidden = !label;
    if (label) more.querySelector('.t-qa__more-name').textContent = label.textContent;
  }

  function revealMore() {
    var wrap = dialog.querySelector('.t-qa__opts');
    var row = rowBelowFold(wrap);
    if (!row) return;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Bring the row's END into view, so its label and every value are on screen. */
    var top = wrap.scrollTop + row.getBoundingClientRect().bottom - wrap.getBoundingClientRect().bottom + 8;
    wrap.scrollTo({ top: top, behavior: calm ? 'auto' : 'smooth' });
  }

  function open(component) {
    if (!dialog) build();

    var data = JSON.parse(component.querySelector('script.t-qa-data').textContent);
    var input = component.querySelector('[ref="variantId"]');
    var seed = data.variants.find(function (v) { return String(v.id) === input.value; })
      || data.variants.find(function (v) { return v.available; })
      || data.variants[0];

    state = { component: component, input: input, data: data, selected: seed.options.slice() };

    var title = dialog.querySelector('.t-qa__title');
    var desc = dialog.querySelector('.t-qa__desc');
    title.textContent = data.title;
    title.href = data.url;
    /* Same source as the PDP tagline (buybox metaobject short_desc); a product
       with none simply doesn't get the line rather than falling back to filler. */
    desc.textContent = data.desc || '';
    desc.hidden = !data.desc;
    dialog.querySelector('.t-qa__img').alt = data.title;
    setMedia(seed.image || '');

    render();
    lockPage();
    dialog.showModal();
  }

  /* Confirm: spinner on the sheet's own button → the sheet closes → the cart
     drawer opens. Horizon's drawer auto-opens the instant the add resolves, which
     would slide in over the sheet, so we pull `auto-open` for the duration and
     call showDialog() ourselves once the sheet is out of the way. */
  function submit() {
    var variant = resolve();
    if (!variant || !variant.available || state.busy) return;
    state.busy = true;

    var d = state.data;
    var component = state.component;
    var add = dialog.querySelector('.t-qa__add');
    var drawer = document.querySelector('cart-drawer-component[auto-open]');

    add.disabled = true;
    add.textContent = '';
    add.classList.add('is-loading');
    if (drawer) drawer.removeAttribute('auto-open');

    state.input.value = variant.id;
    state.input.disabled = false;

    var settled = false;
    function finish(ok) {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      component.removeEventListener('cart:update', onAdd);
      component.removeEventListener('cart:error', onError);
      add.classList.remove('is-loading');

      if (!ok) {
        if (drawer) drawer.setAttribute('auto-open', '');
        add.removeAttribute('aria-label');
        add.disabled = false;
        add.textContent = d.labels.cta;
        state.busy = false;
        return;
      }

      /* Hand straight over to the cart drawer: it IS the confirmation, so the
         sheet closes the moment the add resolves rather than dwelling on its own
         checkmark while the drawer slides in over it. */
      add.setAttribute('aria-label', d.labels.added);
      /* Unlock BEFORE close(), not via its handler: `close()` fires its event on a
         queued task, so the handler would run AFTER the drawer below has opened. The
         cart drawer takes its own scroll lock on open and remembers window.scrollY at
         that moment — with our lock still on, that reads 0, and closing the drawer
         drops the shopper at the top of the collection. Restoring the offset here
         means the drawer records the real one. The close handler still calls this; it
         no-ops once the lock is off. */
      unlockPage();
      dialog.close();
      if (drawer) {
        drawer.setAttribute('auto-open', '');
        drawer.showDialog();
      }
    }

    var onAdd = function () { finish(true); };
    var onError = function () { finish(false); };
    component.addEventListener('cart:update', onAdd);
    component.addEventListener('cart:error', onError);
    var timer = setTimeout(function () { finish(false); }, ADD_TIMEOUT);

    component.querySelector('form').requestSubmit();
  }

  /* Safety net: the sheet must never be left sitting under the cart drawer. The
     happy path already closes it before calling showDialog(), but the cart can
     also be updated by something we don't drive (Horizon's own auto-open racing
     us, a drawer we failed to find, a second add). Any cart update means the add
     is done and the sheet has nothing left to say — close it. */
  document.addEventListener('cart:update', function () {
    if (dialog && dialog.open) dialog.close();
  }, true);

  /* Capture phase: beat both the form submit and the card's link overlay. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    /* Never let a click inside the sheet re-enter open() — the close button, the
       option cards and the CTA all live in a <dialog> on <body>, but a future
       move of the node (or a nested form) would otherwise get swallowed here. */
    if (dialog && e.target.closest('.t-qa')) return;
    var component = e.target.closest('product-form-component[data-t-qa]');
    if (!component) return;

    var button = e.target.closest('button');
    if (!button || button.disabled) return;

    e.preventDefault();
    e.stopPropagation();
    if (directAdd(component, button)) return;
    open(component);
  }, true);

  /* Model already picked on the page (product-list publishes it on <html> as
     data-t-qa-model when its "direct add" option is on): if this product's options
     include that model, add that variant straight away — no sheet. Other options keep
     what the card currently holds (e.g. the colour dot). Anything that doesn't resolve
     to one available variant falls back to the sheet. */
  function norm(x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function directAdd(component, button) {
    var want = document.documentElement.getAttribute('data-t-qa-model');
    if (!want) return false;
    var data;
    try { data = JSON.parse(component.querySelector('script.t-qa-data').textContent); } catch (err) { return false; }
    var input = component.querySelector('[ref="variantId"]');
    var idx = -1, hit = null;
    (data.options || []).forEach(function (o, i) {
      if (idx > -1) return;
      (o.values || []).forEach(function (v) { if (!hit && norm(v.name) === want) { hit = v.name; idx = i; } });
    });
    if (idx < 0) return false;
    var cur = data.variants.find(function (v) { return String(v.id) === input.value; }) || data.variants[0];
    var target = cur.options.slice();
    target[idx] = hit;
    var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === target[i]; }); })
      || data.variants.find(function (x) { return x.options[idx] === hit && x.available; });
    if (!v || !v.available) return false;
    input.value = v.id;
    input.disabled = false;
    button.classList.add('is-loading');
    var done = function () {
      button.classList.remove('is-loading');
      component.removeEventListener('cart:update', done);
      component.removeEventListener('cart:error', done);
    };
    component.addEventListener('cart:update', done);
    component.addEventListener('cart:error', done);
    setTimeout(done, ADD_TIMEOUT);
    component.querySelector('form').requestSubmit();
    return true;
  }
})();
